import { Construction } from 'lucide-react';
import { PageHeader } from '../../app/PageHeader';
import { Card, Grid } from '../../components/Card';
import { Badge } from '../../components/Badge';
import type { ModuleDef } from '../../config/modules';

/** Routed page for a Phase 1 module that is not built yet: title, subtitle and the planned KPIs. */
export function PlaceholderPage({ mod }: { mod: ModuleDef }) {
  return (
    <>
      <PageHeader mod={{ ...mod, tabs: undefined }} />
      <Grid>
        <Card
          span={8}
          title="Planned for this page"
          subtitle={mod.kpiSource ?? 'From the leadership dashboard design (spec v2)'}
          footer={<Badge tone="blue">Coming next</Badge>}
        >
          <ul className="placeholder-list">
            {mod.kpis.map((k) => (
              <li key={k}>{k}</li>
            ))}
          </ul>
        </Card>
        <Card span={4} title="Status">
          <div className="empty" style={{ padding: '12px 0' }}>
            <Construction size={28} strokeWidth={1.5} />
            <div className="empty-title">Not built yet</div>
            <div>
              {mod.note ??
                'This screen is routed and access-controlled; its data comes from the API once the backend serves it.'}
            </div>
          </div>
        </Card>
      </Grid>
    </>
  );
}
